// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"br_dX","cartIcon":"br_dX","badge":"br_dY"};